<template>
  <div class="geofence-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewDataLocal"
        class="modern-modal__overlay"
        @click.self="handleClose">
        <div class="modern-modal modern-modal--xl">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">{{ title }}</h3>
              <p class="modern-modal__subtitle" v-if="geoName">
                {{ geoName }}<span v-if="geoType"> [{{ geoType }}]</span>
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="handleClose">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="geofence-modal__content">
              <GeofeceData
                @deleteGeo="deleteGeo"
                @editGeo="clickEdit"
                :dataEdit="dataEdit"
                :dataCoordinate="dataCoor"
                :geoType="geoType"
                :geoName="geoName" />
            </div>
          </section>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import * as REPO from '../../../repository/index'
import GeofeceData from './GeofenceViewData.vue'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    geoType: String,
    allData: Array,
    dataCoordinate: Array,
    alertData: Array,
    geoName: String,
    fleetGroupData: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  components: {
    GeofeceData,
  },
  watch: {
    editMode(val) {
      if (val) {
        // this.s_alert = this.dataEdit.alert_id;
        // this.calculateFleetEdit(this.s_alert);
        // this.fleetGroup = this.dataEdit.fleet_group_id;
        //
      } else {
        //
      }
    },
    s_alert(val) {
      this.calculateFleet(val)
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        let isOpen = false
        if (typeof this.addNewData === 'string') {
          const normalized = this.addNewData.trim().toLowerCase()
          if (normalized === 'true' || normalized === 'false') {
            isOpen = normalized === 'true'
          } else {
            try {
              isOpen = JSON.parse(this.addNewData)
            } catch (e) {
              isOpen = !!this.addNewData
            }
          }
        } else {
          isOpen = !!this.addNewData
        }

        if (isOpen) {
          this.dataCoor = Array.isArray(this.dataCoordinate)
            ? this.dataCoordinate
            : []
        } else {
          this.dataCoor = []
        }

        return isOpen
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      alert_array: [],
      fleet_array: [],
      s_alert: '',
      dataCoor: [],
      fleetGroup: '',
    }
  },
  methods: {
    deleteGeo() {
      this.$emit('deleteModal')
    },
    clickEdit() {
      //
      this.$emit('closeModal')
    },
    handleClose() {
      this.$emit('closeModal')
    },
  },
}
</script>
<style>
#content-area.content-area-default .geofence-modal-root .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .geofence-modal-root .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .geofence-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced) .geofence-modal-root .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .geofence-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>

<style scoped>
.geofence-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(1100px, 96vw);
  max-height: 92vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal--xl {
  width: min(1100px, 96vw);
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 32px 16px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  line-height: 1.4;
  color: #64748b;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 0 32px 32px;
  display: flex;
  flex: 1;
}

.geofence-modal__content {
  width: 100%;
  min-height: 70vh;
}

.modern-modal__body ::v-deep(.vx-card) {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: none;
}

.modern-modal__body ::v-deep(.vx-card__no-body) {
  padding: 0;
}

.modern-modal__body ::v-deep(.heights) {
  height: calc(80vh - 160px);
}

@media (max-width: 768px) {
  .modern-modal {
    width: min(950px, 96vw);
  }

  .modern-modal__header,
  .modern-modal__body {
    padding-left: 20px;
    padding-right: 20px;
  }

  .modern-modal__body ::v-deep(.heights) {
    height: calc(75vh - 160px);
  }
}
</style>
